import { render, staticRenderFns } from "./visualizar_formato.vue?vue&type=template&id=33ec9148&scoped=true"
import script from "./visualizar_formato.vue?vue&type=script&lang=js"
export * from "./visualizar_formato.vue?vue&type=script&lang=js"
import style0 from "./visualizar_formato.vue?vue&type=style&index=0&id=33ec9148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ec9148",
  null
  
)

export default component.exports